
function utilQuestion() {

}
function initQuestion () {
  let question = [];
  let value1 = [];
  value1.push('﻿0202','0203','0204','0205','0206','0207','0208','0209','0210','0211','0212');
  question.push({'key': '0202','value':value1});
  let value2 = [];
  value2.push('0202','0204','0205','0206','0207','0208','0209','0210','0211','0212');
  question.push({'key': '0203','value':value2});
  let value3 = [];
  value3.push('0202','0203','0205','0206','0207','0208','0209','0210','0211','0212');
  question.push({'key': '0204','value':value3});
  let value4 = [];
  value4.push('0202','0203','0204','0206','0207','0208','0209','0210','0211','0212');
  question.push({'key': '0205','value':value4});
  let value5 = [];
  value5.push('0202','0203','0204','0205','0206','0208','0209','0210','0211','0212');
  question.push({'key': '0207','value':value5});
  let value6 = [];
  value6.push('0202','0203','0204','0205','0206','0207','0208','0209','0211','0212');
  question.push({'key': '0210','value':value6});
  let value7 = [];
  value7.push('0202','0203','0204','0205','0206','0207','0208','0209','0210','0212');
  question.push({'key': '0211','value':value7});
  let value8 = [];
  value8.push('0202','0203','0204','0205','0206','0207','0208','0209','0210','0211');
  question.push({'key': '0212','value':value8});
  let value9 = [];
  value9.push('0232');
  question.push({'key': '0231','value':value9});
  let value10 = [];
  value10.push('0231');
  question.push({'key': '0232','value':value10});
  let value11 = [];
  value11.push('0302');
  question.push({'key': '0301','value':value11});
  let value12 = [];
  value12.push('0301');
  question.push({'key': '0302','value':value12});
  let value13 = [];
  value13.push('0304');
  question.push({'key': '0303','value':value13});
  let value14 = [];
  value14.push('0303');
  question.push({'key': '0304','value':value14});
  let value15 = [];
  value15.push('0422');
  question.push({'key': '0421','value':value15});
  let value16 = [];
  value16.push('0421');
  question.push({'key': '0422','value':value16});
  let value17 = [];
  value17.push('0502','0503','0504','0505','0506','0507','0508','0509','0510','0511');
  question.push({'key': '0501','value':value17});
  let value18 = [];
  value18.push('0501','0503','0504','0505','0506','0507','0508','0509','0510','0511');
  question.push({'key': '0502','value':value18});
  let value19 = [];
  value19.push('0501','0502','0504','0505','0506','0507','0508','0509','0510','0511');
  question.push({'key': '0503','value':value19});
  let value20 = [];
  value20.push('0501','0502','0503','0505','0506','0507','0508','0509','0510','0511');
  question.push({'key': '0504','value':value20});
  let value21 = [];
  value21.push('0501','0502','0503','0504','0506','0507','0508','0509','0510','0511');
  question.push({'key': '0505','value':value21});
  let value22 = [];
  value22.push('0501','0502','0503','0504','0505','0507','0508','0509','0510','0511');
  question.push({'key': '0506','value':value22});
  let value23 = [];
  value23.push('0501','0502','0503','0504','0505','0506','0508','0509','0510','0511');
  question.push({'key': '0507','value':value23});
  let value24 = [];
  value24.push('0501','0502','0503','0504','0505','0506','0507','0509','0510','0511');
  question.push({'key': '0508','value':value24});
  let value25 = [];
  value25.push('0501','0502','0503','0504','0505','0506','0507','0508','0510','0511');
  question.push({'key': '0509','value':value25});
  let value26 = [];
  value26.push('0501','0502','0503','0504','0505','0506','0507','0508','0509','0511');
  question.push({'key': '0510','value':value26});
  let value27 = [];
  value27.push('0501','0502','0503','0504','0505','0506','0507','0508','0509','0510');
  question.push({'key': '0511','value':value27});
  let value28 = [];
  value28.push('0513');
  question.push({'key': '0512','value':value28});
  let value29 = [];
  value29.push('0512');
  question.push({'key': '0513','value':value29});
  let value30 = [];
  value30.push('0523');
  question.push({'key': '0522','value':value30});
  let value31 = [];
  value31.push('0522');
  question.push({'key': '0523','value':value31});
  let value32 = [];
  value32.push('0614');
  question.push({'key': '0613','value':value32});
  let value33 = [];
  value33.push('0613');
  question.push({'key': '0614','value':value33});
  let value34 = [];
  value34.push('0619');
  question.push({'key': '0618','value':value34});
  let value35 = [];
  value35.push('0618');
  question.push({'key': '0619','value':value35});
  let value36 = [];
  value36.push('0711');
  question.push({'key': '0710','value':value36});
  let value37 = [];
  value37.push('0710');
  question.push({'key': '0711','value':value37});
  let value38 = [];
  value38.push('0714');
  question.push({'key': '0713','value':value38});
  let value39 = [];
  value39.push('0713');
  question.push({'key': '0714','value':value39});
  let value40 = [];
  value40.push('0806','0807','0808','0809');
  question.push({'key': '0805','value':value40});
  let value41 = [];
  value41.push('0805','0807','0808','0809');
  question.push({'key': '0806','value':value41});
  let value42 = [];
  value42.push('0805','0806','0808','0809');
  question.push({'key': '0807','value':value42});
  let value43 = [];
  value43.push('0805','0806','0807','0809');
  question.push({'key': '0808','value':value43});
  let value44 = [];
  value44.push('0805','0806','0807','0808');
  question.push({'key': '0809','value':value44});
  let value45 = [];
  value45.push('0812','0813','0814');
  question.push({'key': '0811','value':value45});
  let value46 = [];
  value46.push('0811','0813','0814');
  question.push({'key': '0812','value':value46});
  let value47 = [];
  value47.push('0811','0812','0814');
  question.push({'key': '0813','value':value47});
  let value48 = [];
  value48.push('0811','0812','0813');
  question.push({'key': '0814','value':value48});
  let value49 = [];
  value49.push('0902');
  question.push({'key': '0901','value':value49});
  let value50 = [];
  value50.push('0901');
  question.push({'key': '0902','value':value50});
  let value51 = [];
  value51.push('0904','0905');
  question.push({'key': '0903','value':value51});
  let value52 = [];
  value52.push('0903','0905');
  question.push({'key': '0904','value':value52});
  let value53 = [];
  value53.push('0903','0904');
  question.push({'key': '0905','value':value53});
  let value54 = [];
  value54.push('0915');
  question.push({'key': '0914','value':value54});
  let value55 = [];
  value55.push('0914');
  question.push({'key': '0915','value':value55});
  let value56 = [];
  value56.push('0920','0921','0922','0923','0925');
  question.push({'key': '0919','value':value56});
  let value57 = [];
  value57.push('0919','0921','0922','0923','0925');
  question.push({'key': '0920','value':value57});
  let value58 = [];
  value58.push('0919','0920','0922','0923','0925');
  question.push({'key': '0921','value':value58});
  let value59 = [];
  value59.push('0919','0920','0921','0923','0925');
  question.push({'key': '0922','value':value59});
  let value60 = [];
  value60.push('0919','0920','0921','0922','0925');
  question.push({'key': '0923','value':value60});
  let value61 = [];
  value61.push('0919','0920','0921','0922','0923','0925');
  question.push({'key': '0924','value':value61});
  let value62 = [];
  value62.push('0919','0920','0921','0922','0923');
  question.push({'key': '0925','value':value62});
  let value63 = [];
  value63.push('0928');
  question.push({'key': '0927','value':value63});
  let value64 = [];
  value64.push('0927');
  question.push({'key': '0928','value':value64});
  let value65 = [];
  value65.push('0930','0931','0932');
  question.push({'key': '0929','value':value65});
  let value66 = [];
  value66.push('0929','0931','0932');
  question.push({'key': '0930','value':value66});
  let value67 = [];
  value67.push('0929','0930','0932');
  question.push({'key': '0931','value':value67});
  let value68 = [];
  value68.push('0929','0930','0931');
  question.push({'key': '0932','value':value68});
  let value69 = [];
  value69.push('1003','1006');
  question.push({'key': '1002','value':value69});
  let value70 = [];
  value70.push('1002','1006');
  question.push({'key': '1003','value':value70});
  let value71 = [];
  value71.push('1002','1003','1009','1010','1011');
  question.push({'key': '1006','value':value71});
  let value72 = [];
  value72.push('1006','1010','1011');
  question.push({'key': '1009','value':value72});
  let value73 = [];
  value73.push('1006','1009','1011');
  question.push({'key': '1010','value':value73});
  let value74 = [];
  value74.push('1006','1009','1010');
  question.push({'key': '1011','value':value74});
  let value75 = [];
  value75.push('1016');
  question.push({'key': '1015','value':value75});
  let value76 = [];
  value76.push('1015');
  question.push({'key': '1016','value':value76});
  let value77 = [];
  value77.push('1018');
  question.push({'key': '1017','value':value77});
  let value78 = [];
  value78.push('1017');
  question.push({'key': '1018','value':value78});
  let value79 = [];
  value79.push('1026');
  question.push({'key': '1024','value':value79});
  let value80 = [];
  value80.push('1024');
  question.push({'key': '1026','value':value80});
  let value81 = [];
  value81.push('1032');
  question.push({'key': '1030','value':value81});
  let value82 = [];
  value82.push('1030');
  question.push({'key': '1032','value':value82});
  let value83 = [];
  value83.push('1102');
  question.push({'key': '1101','value':value83});
  let value84 = [];
  value84.push('1101');
  question.push({'key': '1102','value':value84});
  let value85 = [];
  value85.push('1109','1110');
  question.push({'key': '1104','value':value85});
  let value86 = [];
  value86.push('1115');
  question.push({'key': '1105','value':value86});
  let value87 = [];
  value87.push('1104','1110');
  question.push({'key': '1109','value':value87});
  let value88 = [];
  value88.push('1104','1109');
  question.push({'key': '1110','value':value88});
  let value89 = [];
  value89.push('1117','1118');
  question.push({'key': '1116','value':value89});
  let value90 = [];
  value90.push('1116','1118');
  question.push({'key': '1117','value':value90});
  let value91 = [];
  value91.push('1116','1117');
  question.push({'key': '1118','value':value91});
  let value92 = [];
  value92.push('1202','1203');
  question.push({'key': '1201','value':value92});
  let value93 = [];
  value93.push('1201','1203');
  question.push({'key': '1202','value':value93});
  let value94 = [];
  value94.push('1201','1202');
  question.push({'key': '1203','value':value94});
  let value95 = [];
  value95.push('1205','1206');
  question.push({'key': '1204','value':value95});
  let value96 = [];
  value96.push('1204','1206');
  question.push({'key': '1205','value':value96});
  let value97 = [];
  value97.push('1204','1205');
  question.push({'key': '1206','value':value97});
  let value98 = [];
  value98.push('1208');
  question.push({'key': '1207','value':value98});
  let value99 = [];
  value99.push('1207');
  question.push({'key': '1208','value':value99});
  let value100 = [];
  value100.push('1210','1211');
  question.push({'key': '1209','value':value100});
  let value101 = [];
  value101.push('1209','1211');
  question.push({'key': '1210','value':value101});
  let value102 = [];
  value102.push('1209','1210');
  question.push({'key': '1211','value':value102});
  let value103 = [];
  value103.push('1214','1215');
  question.push({'key': '1213','value':value103});
  let value104 = [];
  value104.push('1213','1215');
  question.push({'key': '1214','value':value104});
  let value105 = [];
  value105.push('1213','1214');
  question.push({'key': '1215','value':value105});
  let value106 = [];
  value106.push('1217');
  question.push({'key': '1216','value':value106});
  let value107 = [];
  value107.push('1216');
  question.push({'key': '1217','value':value107});
  let value108 = [];
  value108.push('1226');
  question.push({'key': '1225','value':value108});
  let value109 = [];
  value109.push('1225');
  question.push({'key': '1226','value':value109});
  let value110 = [];
  value110.push('1302');
  question.push({'key': '1301','value':value110});
  let value111 = [];
  value111.push('1301');
  question.push({'key': '1302','value':value111});
  let value112 = [];
  value112.push('1315','1316');
  question.push({'key': '1314','value':value112});
  let value113 = [];
  value113.push('1314','1316');
  question.push({'key': '1315','value':value113});
  let value114 = [];
  value114.push('1314','1315');
  question.push({'key': '1316','value':value114});
  let value115 = [];
  value115.push('1422','1423','1424','1425','1426','1427','1428','1429','1430');
  question.push({'key': '1421','value':value115});
  let value116 = [];
  value116.push('1421','1423','1424','1425','1426','1427','1428','1429','1430');
  question.push({'key': '1422','value':value116});
  let value117 = [];
  value117.push('1421','1422','1424','1425','1426','1427','1428','1429','1430');
  question.push({'key': '1423','value':value117});
  let value118 = [];
  value118.push('1421','1422','1423','1425','1426','1427','1428','1429','1430');
  question.push({'key': '1424','value':value118});
  let value119 = [];
  value119.push('1421','1422','1423','1424','1426','1427','1428','1429','1430');
  question.push({'key': '1425','value':value119});
  let value120 = [];
  value120.push('1421','1422','1423','1424','1425','1427','1428','1429','1430');
  question.push({'key': '1426','value':value120});
  let value121 = [];
  value121.push('1421','1422','1423','1424','1425','1426','1428','1429','1430');
  question.push({'key': '1427','value':value121});
  let value122 = [];
  value122.push('1421','1422','1423','1424','1425','1426','1427','1429','1430');
  question.push({'key': '1428','value':value122});
  let value123 = [];
  value123.push('1421','1422','1423','1424','1425','1426','1427','1428','1430');
  question.push({'key': '1429','value':value123});
  let value124 = [];
  value124.push('1421','1422','1423','1424','1425','1426','1427','1428','1429');
  question.push({'key': '1430','value':value124});
  let value125 = [];
  value125.push('1433');
  question.push({'key': '1431','value':value125});
  let value126 = [];
  value126.push('1431');
  question.push({'key': '1433','value':value126});
  let value127 = [];
  value127.push('1518');
  question.push({'key': '1516','value':value127});
  let value128 = [];
  value128.push('1516');
  question.push({'key': '1518','value':value128});
  let value129 = [];
  value129.push('1530','1531');
  question.push({'key': '1529','value':value129});
  let value130 = [];
  value130.push('1529','1531');
  question.push({'key': '1530','value':value130});
  let value131 = [];
  value131.push('1529','1530');
  question.push({'key': '1531','value':value131});
  let value132 = [];
  value132.push('1535');
  question.push({'key': '1534','value':value132});
  let value133 = [];
  value133.push('1534');
  question.push({'key': '1535','value':value133});
  let value134 = [];
  value134.push('1537');
  question.push({'key': '1536','value':value134});
  let value135 = [];
  value135.push('1536');
  question.push({'key': '1537','value':value135});
  let value136 = [];
  value136.push('1634','1635');
  question.push({'key': '1633','value':value136});
  let value137 = [];
  value137.push('1633','1635');
  question.push({'key': '1634','value':value137});
  let value138 = [];
  value138.push('1633','1634');
  question.push({'key': '1635','value':value138});
  let value139 = [];
  value139.push('1645');
  question.push({'key': '1644','value':value139});
  let value140 = [];
  value140.push('1644');
  question.push({'key': '1645','value':value140});
  let value141 = [];
  value141.push('1703');
  question.push({'key': '1702','value':value141});
  let value142 = [];
  value142.push('1702');
  question.push({'key': '1703','value':value142});
  let value143 = [];
  value143.push('1710');
  question.push({'key': '1708','value':value143});
  let value144 = [];
  value144.push('1708');
  question.push({'key': '1710','value':value144});
  let value145 = [];
  value145.push('1714');
  question.push({'key': '1713','value':value145});
  let value146 = [];
  value146.push('1713');
  question.push({'key': '1714','value':value146});
  let value147 = [];
  value147.push('1804');
  question.push({'key': '1802','value':value147});
  let value148 = [];
  value148.push('1802');
  question.push({'key': '1804','value':value148});
  let value149 = [];
  value149.push('1835','1837');
  question.push({'key': '1832','value':value149});
  let value150 = [];
  value150.push('1832','1837');
  question.push({'key': '1835','value':value150});
  let value151 = [];
  value151.push('1832','1835');
  question.push({'key': '1837','value':value151});
  let value152 = [];
  value152.push('1840','1841');
  question.push({'key': '1839','value':value152});
  let value153 = [];
  value153.push('1839','1841');
  question.push({'key': '1840','value':value153});
  let value154 = [];
  value154.push('1839','1840');
  question.push({'key': '1841','value':value154});
  let value155 = [];
  value155.push('2008');
  question.push({'key': '2007','value':value155});
  let value156 = [];
  value156.push('2007');
  question.push({'key': '2008','value':value156});
  let value157 = [];
  value157.push('2010');
  question.push({'key': '2009','value':value157});
  let value158 = [];
  value158.push('2009');
  question.push({'key': '2010','value':value158});
  return question;
}

utilQuestion.initQuestion = initQuestion;
export default utilQuestion;



// WEBPACK FOOTER //
// ./src/libs/utilQuestion.js